const filterButtonsSingleInspiration = document.querySelectorAll(
  ".js-filterButtonSingleInspiration"
);

if (filterButtonsSingleInspiration.length > 0) {
  //Un-comment this to add the hover effect
  fetchAndBuildGuideData(filterButtonsSingleInspiration);
}

async function fetchAndBuildGuideData(filterButtons) {
  try {
    const response = await fetch(
      `${window.location.origin}/wp-json/atta45/v1/all-guides`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
    //Get all guides from database
    const guidesData = await response.json();
    buildHoverGuide(guidesData, filterButtons);
  } catch (error) {
    console.error(error);
  }
}

function buildHoverGuide(guidesData, filterButtons) {
  const tabParent = document.querySelector(".js-singleProjectTabs");

  const hoverSection = document.createElement("section");
  hoverSection.classList.add("SingleInspiration-guideHoverSection");
  tabParent.appendChild(hoverSection);

  const contentWrapper = document.createElement("div");
  contentWrapper.classList.add(
    "SingleInspiration-guideHoverSection--contentWrapper"
  );
  hoverSection.appendChild(contentWrapper);

  const imagesWrapper = document.createElement("div");
  imagesWrapper.classList.add(
    "SingleInspiration-guideHoverSection--imageWrapper"
  );
  hoverSection.appendChild(imagesWrapper);

  const imgTags = [];

  for (let i = 0; i < 3; i++) {
    const figureTag = document.createElement("figure");
    imagesWrapper.appendChild(figureTag);
    const imgTag = document.createElement("img");
    imgTags.push(imgTag);
    imgTag.src = "";
    imgTag.style.display = "none";
    figureTag.appendChild(imgTag);
  }

  //Get "en" if english or something else if swedish
  let firstSubUrl = window.location.pathname.split("/")[1];

  for (let i = 0; i < filterButtons.length; i++) {
    const filterButton = filterButtons[i];
    const guideWordId = filterButton.dataset.guideWordId;
    if (guideWordId === "") {
      continue;
    }

    for (let j = 0; j < guidesData.length; j++) {
      const guideItem = guidesData[j];
      if (guideItem["ID"] != guideWordId) {
        continue;
      }

      filterButton.addEventListener("mouseenter", () => {
        hoverSection.style.display = "flex";

        //only display the guideItem[post_content] or the guideItem[post_content_en]'s first paragrahp (<p></p> tag)

        let firstParagraph = guideItem["post_content"].split("</p>")[0];
        if (firstSubUrl === "en") {
          firstParagraph = guideItem["post_content_en"].split("</p>")[0];
        }

        contentWrapper.innerHTML = firstParagraph;
        const nrOfLoops = Math.min(3, guideItem["imageUrls"].length);
        for (let k = 0; k < nrOfLoops; k++) {
          const imageUrl = guideItem["imageUrls"][k];
          if (!imageUrl || imageUrl == "") {
            continue;
          }
          imgTags[k].src = imageUrl;
          imgTags[k].style.display = "block";
        }
      });

      filterButton.addEventListener("mouseleave", () => {
        hoverSection.style.display = "none";
        imgTags.forEach((imgTag) => {
          imgTag.style.display = "none";
        });
      });
    }
  }
}
